module.exports = __webpack_public_path__ + "img/23.3922e057.jpg";